import { AppID, SLA_FILTER_TIME, URL, USER, ValidateLocalStorageToken } from '../../constants/provider/constant';
import axios from 'axios';
import { axiosFinal, _axios } from '../../plugins/axios';
import ClevertapReact from 'clevertap-react';
import moment from 'moment';

export const AppointmentDetails = (searchObj, pageNo, firstDate, endDate, statusId, slaBreachType, isCountRequired=false) => {
  let obj = {};
  if (searchObj != null && searchObj.Id != null && searchObj.Name != null && !(searchObj?.Id?.length == 1 && searchObj?.Id[0].trim() == '')) {
    const key = searchObj.Name;
    const id = Array.isArray(searchObj.Id) ? searchObj.Id : [searchObj.Id]
    switch (key) {
      case 'Request Id': obj = { requestId: id }; break;
      case 'Employee Id': obj = { employeeId: id }; break;
      case 'Name': obj = { name: id }; break;
      case 'Phone Number': obj = { phoneNumber: id }; break;
      case 'Email': obj = { email: id }; break;
      default: obj = {}; break;
    }
  }
  let user = JSON.parse(localStorage.getItem('user_details'));

  let dataAllAppointments = {
    contractId: 0,
    daysOfAppointment: 0,
    fetchByDate: "apptdate",
    fromDateOfAppointment: firstDate,
    hashtagFilters: obj,
    ipAddress: "String",
    loadFullDetails: false,
    pageNo: pageNo,
    masterLogin: Boolean(user?.parentProvider?.isParent ?? false),
    providerId: user.providerId,
    requestAccessToken: localStorage.getItem("access_token") ? JSON.parse(localStorage.getItem("access_token")) : null,
    requestType: "",
    rows: 10,
    searchType: 1,
    statusId: statusId,
    toDateOfAppointment: endDate,
    userAgent: "String",
    isCountRequired: isCountRequired,
    slaBreachType: slaBreachType,
    slaBreachTime: SLA_FILTER_TIME[slaBreachType],
    isSearch:searchObj && searchObj.isSearch ?true :false
  }
  // if()

  let config = {
    method: 'post',
    url: URL.providercore_url+'provider/Appointments/',
    headers: {
      accesstoken: JSON.parse(localStorage.getItem("access_token")),
      'accept': 'application/json, text/plain, */*',
    },
    data: dataAllAppointments
  };

  return _axios(config)
    .then((response) =>{
      // if(!response.data.isSuccess) 
      // cleverTap("appointmentsFetchFailed", {
      //   message:response.data.errorMessage
      // })
      // else cleverTap("appointmentsFetched", {})
      return response.data;
    })
    .catch((error) => {
      if (error.response) {
        let errorObj = {
          errorStatus: error.response.status,
          errorResponse: error.response
        }
        return errorObj
      }
    });
}

export const MaskElement = (elementToMask,additionals) => {
  let strToMask = '' ;
  if(elementToMask){
    for(let i = 0; i< elementToMask.length; i++){
      if( i > 4  ){
        if(additionals && additionals.DNDCustomer){
          strToMask = strToMask + '*'
        } 
        else if(additionals && additionals.DND){
          strToMask = strToMask + '*'
        }
        else{
          strToMask = strToMask + elementToMask[i]
        }
      }
     else{
      strToMask = strToMask + elementToMask[i]
     }
    }
  }
  return strToMask;
}


export const getAge = (dateOfBirth) => {
  if (!dateOfBirth || dateOfBirth === "/Date(-62135596800000-0000)/")
    return;
  else {
    var dob = new Date(parseInt(dateOfBirth.replace('/Date(', '').replace(')/', ''), 10))
    var today = new Date();
    var age = Math.floor((today - dob) / (365.25 * 24 * 60 * 60 * 1000));
    return age;
  }
}

export const getDateObj = (inputDate) => {
  if (inputDate) {
    var d = new Date(parseInt(inputDate.replace('/Date(', '').replace(')/', ''), 10))
    return new Date(d);
  }
}


export const getCustomDate = (date) => {
  let newDate = moment(date.toString()).utc().format("DD-MMM-YYYY")
  // let customDate = date.getDate();
  // let year = date.getFullYear();
  // let month = date.toLocaleString('default', { month: 'short' });
  // let dateStr = customDate + "-" + month + "-" + year;
  // return dateStr;
  return newDate
}
// export const getCustomDate = (date) => {
//   let customDate = date.getDate();
//   let year = date.getFullYear();
//   let month = date.toLocaleString('default', { month: 'short' });
//   let dateStr = customDate + "-" + month + "-" + year;
//   return dateStr;
// }

export const formatAMPM = (date) => {
  let newDate = moment(date.toString()).utc().format("h:mm A")
  // var hours = date.getHours();
  // var minutes = date.getMinutes();
  // var ampm = hours >= 12 ? 'PM' : 'AM';
  // hours = hours % 12;
  // hours = hours ? hours : 12; // the hour '0' should be '12'
  // minutes = minutes < 10 ? '0' + minutes : minutes;
  // var strTime = hours + ':' + minutes + ' ' + ampm;
  // return strTime;
  return newDate
}

export const getAppointmentDate = (fulfillmentDate) => {
  let date = new Date(fulfillmentDate);
  return date.toDateString();
}

export const timeConvert = (time) => {
  time = time.toString ().match (/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

  if (time.length > 1) { 
    time = time.slice (1);  
    time[5] = +time[0] < 12 ? ' AM' : ' PM'; 
    time[0] = +time[0] % 12 || 12; 
  }
  return time.join(''); 
}

export const getCorrectDateFormat = (fulfillmentDate) => {
  let date = fulfillmentDate;
  date = new Date(date);
  return date;
}

export const getAppointmentTime = (fulfillmentDate) => {
  let date = fulfillmentDate;
  date = new Date(date).toTimeString();
  date = date.split(' ')[0]
  return date;
}

export const uploadFile = async (reports) => {
  const payload = reports;
  payload.accessToken = JSON.parse(localStorage.getItem("access_token"));
  try {
    let config = {
      method: 'post',
      url: `${URL.providercore_url}provider/getS3SignedUrl`,
      headers: {
        'accept': 'application/json',
        'accesstoken': JSON.parse(localStorage.getItem("access_token")),
      },
      data: reports
    };
  
    let response = await axiosFinal(config);
    if(response?.status === 200) {
      return response?.data;
    }
  
  } catch(err) {
    console.log(err);
    return err;
  }
}

export const s3FileUpload = async (data, url) => {
  try{
    let config = {
      method: 'PUT',
      url: url,
      headers: {
        'Content-Type': data.type
      },
      data: data
    };
    return axios(config)
      .then((response) => response)
      .catch((error) => error);

  } catch(err) {
    console.log(err);
    return err;
  }
}

export const postFileData = async (data) => {
  try{
    let payload = {
      fileName: data.fileName,
      fileType: data.fileType,
      appId : AppID,
      fileIdentifier: data.fileIdentifier,
      signedURL: data.signedUrl,
      accessToken: JSON.parse(localStorage.getItem("access_token")),
      contractType: data.contractType
    }
    let config = {
      method: 'put',
      url: `${URL.providercore_url}provider/saveFileDocument`,
      headers: {
        'accept': 'application/json',
        'accesstoken': JSON.parse(localStorage.getItem("access_token")),
      },
      data: payload
    };

    let response = await axiosFinal(config);
    if(response?.status === 200) {
      return response?.data;
    }

  } catch(err) {
    console.log(err);
    return err;
  }
}

export const  RouteToDashboard = (history, statusId, stateObject) =>  {
  switch(statusId){
      case 22 : history.push({ pathname: "/" + localStorage.getItem("roleName") + "/appointments/", state: stateObject}); break ;
      case 23 : history.push({ pathname: "/" + localStorage.getItem("roleName") + "/appointments/confirmed", state: stateObject}); break ;
      case 39 : history.push({ pathname: "/" + localStorage.getItem("roleName") + "/appointments/notAttended", state: stateObject}); break ;
      case 32 : history.push({ pathname: "/" + localStorage.getItem("roleName") + "/documents/pending", state: stateObject}); break ;
      case 162 : history.push({ pathname: "/" + localStorage.getItem("roleName") + "/documents/partialReceived", state: stateObject}); break ;
      case 37 : history.push({ pathname: "/" + localStorage.getItem("roleName") + "/documents/received", state: stateObject}); break ;
      case 48 : history.push({ pathname: "/" + localStorage.getItem("roleName") + "/cases/settled", state: stateObject}); break ;
      case 42 : history.push({ pathname: "/" + localStorage.getItem("roleName") + "/cases/cancelled", state: stateObject}); break ;
      case 146 : history.push({ pathname: "/" + localStorage.getItem("roleName") + "/cases/rejected", state: stateObject}); break ;
      default : history.push({ pathname: "/" + localStorage.getItem("roleName") + "/appointments/", state: stateObject}); break;
  }
}

export const GetDashboardData = async ({entityId, startDate, endDate}) => {
  const payload= {
    "startDate": startDate,
    "endDate": endDate,
    "entityId": entityId
  }
  let config = {
    method: 'post',
    url: URL.providercore_url+'provider/dcdashboard/',
    // url: 'http://localhost:8080/provider/dcdashboard/',
    headers: {
      accesstoken: ValidateLocalStorageToken(localStorage.getItem("access_token")) && JSON.parse(localStorage.getItem("access_token")),
      'accept': 'application/json, text/plain, */*',
    },
    data: payload
  };
  try {
    const data = await _axios(config);
    if(data?.status === 200) {
      return {
        status: data.status,
        data: data.data
      };
    } else {
      return data;
    }
  } catch(err) {
    console.log(err, err?.status, err?.message);
    if(err?.response?.status) {
      return {status: err.response.status, msg: err.response.data}
    }
    return err?.message;
  }
}
export const GetTodayDashboardData = async ({
  entityId
  }) => {
    const payload= {
      entityId: entityId
    }
    let config = {
      method: 'post',
      url: URL.providercore_url+'provider/dcDashboardToday/',
      // url: 'http://localhost:8080/provider/dcDashboardToday/',
      headers: {
        accesstoken: ValidateLocalStorageToken(localStorage.getItem("access_token")) && JSON.parse(localStorage.getItem("access_token")),
        'accept': 'application/json, text/plain, */*',
      },
      data: payload
    };
  
    try {
      const data = await _axios(config);
      if(data?.status === 200) {
        return {
          status: data.status,
          data: data.data
        };
      } else {
        return data;
      }
    } catch(err) {
      console.log(err, err?.status, err?.message);
      if(err?.response?.status) {
        return {status: err.response.status, msg: err.response.data}
      }
      return err?.message;
    }
}
export const GetDashboardChartData = async ({
  entityId,
  chartStartDate,
  chartEndDate,
  reportsSlaBreachTime,
  confirmedSlaBreachTime,
  confirmedSlaBreachType,
  reportSlaBreachType}) => {
    const payload= {
      entityId: entityId,
      chartStartDate: chartStartDate,
      chartEndDate: chartEndDate,
      reportsSlaBreachTime: reportsSlaBreachTime,
      confirmedSlaBreachTime: confirmedSlaBreachTime,
      confirmedSlaBreachType: confirmedSlaBreachType,
      reportSlaBreachType: reportSlaBreachType
    }
    let config = {
      method: 'post',
      url: URL.providercore_url+'provider/dcDashboardpercent/',
      // url: 'http://localhost:8080/provider/dcDashboardpercent/',
      headers: {
        accesstoken: ValidateLocalStorageToken(localStorage.getItem("access_token")) && JSON.parse(localStorage.getItem("access_token")),
        'accept': 'application/json, text/plain, */*',
      },
      data: payload
    };
  
    try {
      const data = await _axios(config);
      if(data?.status === 200) {
        return {
          status: data.status,
          data: data.data
        };
      } else {
        return data;
      }
    } catch(err) {
      console.log(err, err?.status, err?.message);
      if(err?.response?.status) {
        return {status: err.response.status, msg: err.response.data}
      }
      return err?.message;
    }
  }

export const getAppointmentDateFormat = (fulfillmentDate) => {
  let date = fulfillmentDate.split('/')[1]
  date = date.split('(')[1];
  date = date.split('-')[0];
  date = new Date(parseInt(date));
  let year = date.getFullYear();
  let month = date.getMonth();
  let day = date.getDate();
  date = new Date(year, month, day);
  let dateObject = new Date(date);
  return dateObject.toDateString();
}


export const getAppointmentTimeFormat = (fulfillmentDate) => {
  let date = fulfillmentDate.split('/')[1]
  date = date.split('(')[1];
  date = date.split('-')[0];
  date = new Date(parseInt(date));
  
  let stringDate =  new Date(date).toUTCString()
  let stringExceptGMT = stringDate.split(' GMT')[0]; 
  stringExceptGMT = stringExceptGMT.split(' ');
  stringExceptGMT = stringExceptGMT[stringExceptGMT.length - 1]
  return stringExceptGMT;
}

export const exportData = async (searchObj, firstDate, endDate, statusId, slaBreachType) => {
  let user = ValidateLocalStorageToken(localStorage.getItem('user_details')) && JSON.parse(localStorage.getItem('user_details'));

  let tokenValid = await checkTokenExpiry();
  if(!tokenValid){
    return {
      "message": "tokenExpired"
    }
  }
  let obj = {};
  if (searchObj != null && searchObj.Id != null && searchObj.Name != null) {
    const key = searchObj.Name;
    const id = Array.isArray(searchObj.Id) ? searchObj.Id : [searchObj.Id]
    switch (key) {
      case 'Request Id': obj = { requestId: id }; break;
      case 'Employee Id': obj = { employeeId: id }; break;
      case 'Name': obj = { name: id }; break;
      case 'Phone Number': obj = { phoneNumber: id }; break;
      case 'Email': obj = { email: id }; break;
      default: obj = {}; break;
    }
  }

  let data = {
    entityId:ValidateLocalStorageToken(localStorage.getItem('user_details')) && JSON.parse(localStorage.getItem('user_details'))?.entityId,
    StartDate: firstDate,
    masterLogin: Boolean(user.providers),
    providerId: user.providerId ,
    hashtagFilters: obj,
    StatusId: statusId,
    EndDate: endDate,
    slaBreachType:slaBreachType,
    slaBreachTime : SLA_FILTER_TIME[slaBreachType] 
  }
  let name="";
  switch ( window.location.hash.split('/').pop() ) {
    case '':
      name+="New Appointments";
      break;
  
    case 'appointments':
      name+="New Appointments";
      break;
  
    case 'confirmed':
      name+="Confirmed Appointments";
      break;
  
    case 'pending':
      name+="Documents Pending";
      break;
  
    case 'received':
      name+="Documents Submitted";
      break;
  
    case 'settled':
      name+="Settled";
      break;
  
    case 'cancelled':
      name+="Cancelled";
      break;
  
    case 'notAttended':
      name+="Not Attended";
      break;
  
    case 'rejected':
      name+="Rejected";
      break;
  
    default:
      break;
  }

  if(slaBreachType){
    name+="-Priority Cases"
  }
  
  if(firstDate && endDate){
    name+=`-${firstDate}_${endDate}`;
  }else{
    if(firstDate && !endDate) {
      name+=`-${firstDate}_${new Date().toISOString().split('T')[0]}`
    }else{
      if(endDate && !firstDate){
        name+=`-${moment().subtract("months",6).toISOString().split('T')[0]}_${endDate}`
      }else{
        name+=`-${new Date().toISOString().split('T')[0]}`
      }
    }
  }

  let config = {
    method: 'post',
    url: URL.providercore_url+'provider/DownloadFile/',
    headers: {
      accesstoken: ValidateLocalStorageToken(localStorage.getItem("access_token")) && JSON.parse(localStorage.getItem("access_token")),
      'accept': 'application/json, text/plain, */*',
    },
    responseType:"arraybuffer",
    data: data
  };

  return _axios(config)
    .then((response) =>{
      console.log("response\n",response)
      return response.data;
    })
    .then(data=>( new Blob([data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64" }) ))
    .then(blob=>{return window.URL.createObjectURL(blob)})
    .then(url=>{
      document.getElementById("hiddenDownloadLink").setAttribute("href",url);
      document.getElementById("hiddenDownloadLink").setAttribute("download",name);
      document.getElementById("hiddenDownloadLink").click();
      document.getElementById("hiddenDownloadLink").setAttribute("href","");
    })
    .catch((error) => {
      if (error.response) {
        let errorObj = {
          errorStatus: error.response.status,
          errorResponse: error.response
        }
        return errorObj
      }
    });
}

export const getRequiredDocuments = async (erid,name,isHA=null) => {

  let tokenValid = await checkTokenExpiry();
  if(!tokenValid){
    return {
      "message": "tokenExpired"
    }
  }
  
  let config = {
    method: 'post',
    url: URL.providercore_url+'provider/getRequiredDocuments/',
    headers: {
      accesstoken: USER.access_token,
      'accept': 'application/json, text/plain, */*',
    },
    responseType:"arraybuffer",
    data: {
      erId:erid,
      isHA:isHA,
    }
  };

  return _axios(config)
    .then((response) =>{
      console.log("response\n",response)
      return response.data;
    })
    .then(data=>( new Blob([data], { type: "octet/stream" }) ))
    .then(blob=>{return window.URL.createObjectURL(blob)})
    .then(url=>{
      document.getElementById("hiddenDownloadLink").setAttribute("href",url);
      document.getElementById("hiddenDownloadLink").setAttribute("download",`${name}.zip`);
      document.getElementById("hiddenDownloadLink").click();
      document.getElementById("hiddenDownloadLink").setAttribute("href","");
    })
    .catch((error) => {
      if (error.response) {
        let errorObj = {
          errorStatus: error.response.status,
          errorResponse: error.response
        }
        return errorObj
      }
    });
}

export const getFileDownload = async (fileName, guid) => {

  let tokenValid = await checkTokenExpiry();
  if(!tokenValid){
    return {
      "message": "tokenExpired"
    }
  }
  
  let config = {
    method: 'post',
    url:  URL.providercore_url + 'insurance/DownloadFile',
    headers: {
      accesstoken: USER.access_token,
      'accept': 'application/json, text/plain, */*',
    },
    responseType:"arraybuffer",
    data:{
      "fileGuid":guid?.split('/').pop(),
      "fileName":fileName
  }
  };

  return _axios(config)
    .then((response) =>{
      console.log("response\n",response)
      return response.data;
    })
    .then(data=>( new Blob([data], { type: "octet/stream" }) ))
    .then(blob=>{return window.URL.createObjectURL(blob)})
    .then(url=>{
      document.getElementById("hiddenDownloadLink").setAttribute("href",url);
      document.getElementById("hiddenDownloadLink").setAttribute("download",`${fileName}`);
      document.getElementById("hiddenDownloadLink").click();
      document.getElementById("hiddenDownloadLink").setAttribute("href","");
    })
    .catch((error) => {
      if (error.response) {
        let errorObj = {
          errorStatus: error.response.status,
          errorResponse: error.response
        }
        return errorObj
      }
    });
}

export const cleverTap = (eventName, eventData={}) => {
  let data={
    providerId: ValidateLocalStorageToken(localStorage.getItem("user_details")) && JSON.parse(localStorage.getItem("user_details"))?.providerId,
    providerName: ValidateLocalStorageToken(localStorage.getItem("user_details")) && JSON.parse(localStorage.getItem("user_details"))?.firstName,
    srcType: "web/mWeb",
    srcPage:window.location.hash,
    ...eventData
  }
  if((window.location.hostname === 'labwise.medibuddy.in')  && eventName ){
    ClevertapReact.event(eventName, data);
  }
}

export const getAgeOfUser = (dateString) => {
  var today = new Date();
  var birthDate = new Date(dateString);
  var age = today.getFullYear() - birthDate.getFullYear();
  var m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
  }
  return age;
}

export const  isDateBeforeToday = (date) => {
  return new Date(date.toDateString()) < new Date(new Date().toDateString());
}


export const checkSlaTime = (timeString, breachLimit) => {
  let a = moment(timeString);
  let hrs = moment().diff(a, "hours")
  let days = moment().diff(a, "days")
  let months = moment().diff(a, "months")
  if (months > 0) return { month: months }
  if (hrs < 0) return null;
  if (hrs > 0) {
    if (hrs < breachLimit) return null;
    else {
      if (hrs < 24) return { hour: hrs };
      if (days > 0 && months === 0) return { day: days, hour: (hrs - 24 * days) }
    }
  }
}

export const getOrderPackageDetails = (orderIds, isSplitRequest)=>{
  const config = {
    method: 'post',
    url: URL.providercore_url+'provider/getPackageDetails',
    headers: {  
      'accesstoken': ValidateLocalStorageToken(localStorage.getItem("access_token")) && JSON.parse(localStorage.getItem("access_token")), 
      'content-type': 'application/json', 
    },
    data : {
      "productEntityRelationIds": orderIds
    }
  }

  return _axios(config)
  .then(res=>res.data)
  .catch(err=>err); 
}

const checkTokenExpiry = async () =>{
  const data = {
    applicationId: 5385,
    authToken: ValidateLocalStorageToken(localStorage.getItem("access_token")) && JSON.parse(localStorage.getItem("access_token"))
  }

  var config = {
    method: 'post',
    url: URL.providercore_url+ "provider/validateToken",
    headers: {
        'Content-Type': 'application/json'
    },
    data: data
};

return _axios(config)
.then(res=>{
  console.log(res)
  return res.data})
.then(resp=>{
  if(resp && resp.isSuccess){
    return  true
  }else
    return false
})
.catch(err=>{
  console.log(err);
  return false;
})

}